import { RefObject, useEffect, useState } from 'react';

type LoadStatusType = 'idle' | 'loading' | 'loaded' | 'error' | string;

/** Хук для отслеживанием статуса загрузки изображений */
const useOnLoadImages = (ref: RefObject<HTMLElement>) => {
	const [status, setStatus] = useState<LoadStatusType>('idle');

	useEffect(() => {
		const updateStatus = (
			event: Event | ErrorEvent,
			images: HTMLImageElement[],
			hasError = false,
		) => {
			if (hasError) {
				setStatus((event as ErrorEvent).message);
			}
			const isLoaded = images
				.map((image) => {
					return image.complete;
				})
				.every((item) => {
					return item === true;
				});
			if (isLoaded && event.target) {
				setStatus('loaded');
				(event.target as HTMLImageElement).style.opacity = '1';
			}
		};

		if (!ref?.current) {
			return;
		}
		const imagesLoaded = Array.from(ref.current.querySelectorAll('img'));
		if (imagesLoaded.length === 0) {
			return;
		}
		setStatus('loading');
		imagesLoaded.forEach((image) => {
			image.style.opacity = '0';
			image.addEventListener(
				'load',
				(e) => {
					return updateStatus(e, imagesLoaded);
				},
				{
					once: true,
				},
			);
			image.addEventListener(
				'error',
				(e) => {
					return updateStatus(e, imagesLoaded, true);
				},
				{
					once: true,
				},
			);
		});

		return;
	}, [ref]);

	return [status] as const;
};

export default useOnLoadImages;
